<template>
  <layout-component>
    <div class="banner banner-dashboard">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-2">
            <h1 class="left-bullet" v-html="$t('w.giftcards.title-banner')"></h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container container-giftcard form pb-4">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="row">
            <div class="col-sm current-balance">
              <p>{{'w.giftcards.title'|t}}:</p>
              <span class="current-balance">{{ $store.user.balance }}&euro;</span>
            </div>
          </div>

          <div class="row py-3">
            <div class="col-sm reedem-wrap">
              <h2>{{'w.giftcards.reedem-title'|t}}:</h2>
              <form autocomplete="off" @submit.prevent="reedem" v-if="user" method="post" class="row">

                <div class="form-group col" :class="{ 'has-error': has_error }">
                    <label for="card-code">{{'w.giftcards.label-card-code'|t}}</label>
                    <div class="input-wrapper">
                      <b-form-input type="text" id="card-code" v-model="giftcardCode" placeholder="redeemcode"></b-form-input>
                      <span class="focus-border"></span>
                    </div>
                    <small class="form-text text-danger" v-if="has_error">{{error}}</small>
                </div>

                <div class="form-group col">
                    <b-button type="submit" class="apply" v-bind:disabled="giftcardCode === ''"><span>{{'w.giftcards.reedem-btn'|t}}</span>
                    </b-button>
                </div>
              </form>
            </div>
          </div>

          <div class="row" v-if="giftcards.length">
            <div class="col-sm">
              <h2>{{'w.giftcards.used-cards'|t}}:</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">{{'w.giftcards.th-code'|t}}</th>
                    <th scope="col">{{'w.giftcards.used-date'|t}}</th>
                    <th scope="col">{{'w.giftcards.used-amount'|t}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="giftcard in giftcards" :key="giftcard.id">
                    <td>{{ giftcard.code }}</td>
                    <td>{{ giftcard.used_at ? new Date(giftcard.used_at).toLocaleDateString('fr-FR') : 'Not used' }}</td>
                    <td>{{ giftcard.amount }}&euro;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        user: null,
        has_error: false,
        error: '',
        errors: {},
        giftcards: [],
        giftcardCode: '',
        success: false
      }
    },
    mounted() {
      this.user = this.$auth.user()
      this.getPreviousCards()
    },
    methods: {
      getPreviousCards() {
        Vue.axios.get('/giftcards/index')
        .then(res => {
          this.giftcards = res.data
        })
        .catch(() => {})
      },
      reedem() {
        this.hasError = false
        this.error = ''

        Vue.axios.post('/giftcards/redeem', {
            code: this.giftcardCode
        })
        .then(res => {
            this.success = true
            this.getPreviousCards()
            this.giftcardCode = ''
            this.$store.reloadUser()
        })
        .catch(error => {
            this.has_error = true
            this.error = error.response?.data?.message || 'Une erreur est survenue'
            this.success = false
            this.$store.reloadUser()
        })}
    }
  }
</script>
